// ---------------------- Daktela WebChat ----------------------
var daktelaGuiConfig = {
    "server":"https://comfortclick.daktela.com/",
    "accessToken":"04s3014nn46n719p2or8n177n74s0pp2"
};
// Create async script element
var daktelaWeb = null;
var daktelaScriptEl = document.createElement("script");
(function (attrs) { Object.keys(attrs).forEach(function (key) { daktelaScriptEl.setAttribute(key, attrs[key]); }); })
({"src":daktelaGuiConfig.server+"external/web/web.js", "type":"text/javascript", "async":true, "charset":"utf-8"});
daktelaScriptEl.onload = function() { if (typeof daktelaGui === 'undefined' || !daktelaGui) return; daktelaWeb = new daktelaGui(); daktelaWeb.init(daktelaGuiConfig); };
document.getElementsByTagName("head")[0].appendChild(daktelaScriptEl);
window.addEventListener("load", function () {
  var daktelaWeb = null;
  var daktelaScriptEl = document.createElement("script");

  daktelaScriptEl.src = daktelaGuiConfig.server + "external/web/web.js";
  daktelaScriptEl.type = "text/javascript";
  daktelaScriptEl.async = true;
  daktelaScriptEl.charset = "utf-8";

  daktelaScriptEl.onload = function () {
    if (!daktelaGui) return;
    daktelaWeb = new daktelaGui();
    daktelaWeb.init(daktelaGuiConfig);
  };

  document.head.appendChild(daktelaScriptEl);
});


// ---------------------- Toggle Password ----------------------
document.addEventListener("click", function (event) {
  // Check if the clicked element is the 'eyeIcon'
  if (event.target.classList.contains("newFieldIcon-passwordEye")) {
    
    // Toggle the eye icon state
    event.target.classList.toggle("fa-eye");
    event.target.classList.toggle("fa-eye-slash");
    event.target.classList.toggle("showPassword");

    // Find the input element associated with this icon using the `toggle` attribute
    const inputSelector = event.target.getAttribute("toggle");
    if (inputSelector) {
      const input = document.querySelector(inputSelector);

      if (input) {
        // Toggle the input type between 'password' and 'text'
        input.type = input.type === "password" ? "text" : "password";
      }
    }
  }
});


// ---------------------- All Load  logic ----------------------
window.addEventListener("load", function () {

  // OTP Reset Logic
  const currentUrl = window.location.pathname;
  if (!currentUrl.includes("/account") && !currentUrl.includes("/login")) {
    sessionStorage.removeItem("hasShownOtp");
  }

  // Share Button Logic
  const currentURL = window.location.href;
  const pageTitle = document.title;

  const shareButton = document.querySelector(".shareButton.main");
  const shareGroup = document.querySelector(".groupButton2");

  if (shareButton && shareGroup) {
    shareButton.addEventListener("click", function () {
      shareGroup.classList.toggle("active");
    });

    document.addEventListener("click", function (e) {
      if (!shareButton.contains(e.target) && !shareGroup.contains(e.target)) {
        shareGroup.classList.remove("active");
      }
    });
  }

  const shareButtons = document.querySelectorAll(".social-button");
  shareButtons.forEach((button) => {
    button.addEventListener("click", function () {
      const platform = button.getAttribute("data-platform");

      let shareURL = "";
      switch (platform) {
        case "facebook":
          shareURL = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(currentURL)}`;
          break;
        case "twitter":
          shareURL = `https://twitter.com/intent/tweet?url=${encodeURIComponent(currentURL)}&text=${encodeURIComponent(pageTitle)}`;
          break;
        case "linkedin":
          shareURL = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(currentURL)}`;
          break;
        case "pinterest":
          shareURL = `https://pinterest.com/pin/create/button/?url=${encodeURIComponent(currentURL)}&description=${encodeURIComponent(pageTitle)}`;
          break;
        case "whatsapp":
          shareURL = `https://wa.me/?text=${encodeURIComponent(pageTitle + " " + currentURL)}`;
          break;
        case "email":
          shareURL = `mailto:?subject=${encodeURIComponent(pageTitle)}&body=${encodeURIComponent(currentURL)}`;
          break;
        case "copy":
          navigator.clipboard.writeText(currentURL);
          return;
      }

      if (shareURL) {
        window.open(shareURL, "_blank", "noopener,noreferrer");
      }
    });
  });

  // DOB Dropdown Logic
  const dayDropdown = document.getElementById("select-day");
  const monthDropdown = document.getElementById("select-month");
  const yearDropdown = document.getElementById("select-year");

  if (dayDropdown && monthDropdown && yearDropdown) {
    for (let day = 1; day <= 31; day++) {
      let option = document.createElement("option");
      option.value = day;
      option.textContent = day;
      dayDropdown.appendChild(option);
    }

    const months = [
      "January","February","March","April","May","June",
      "July","August","September","October","November","December"
    ];

    months.forEach((month, index) => {
      let option = document.createElement("option");
      option.value = index + 1;
      option.textContent = month;
      monthDropdown.appendChild(option);
    });

    const currentYear = new Date().getFullYear();
    for (let year = currentYear; year >= 1920; year--) {
      let option = document.createElement("option");
      option.value = year;
      option.textContent = year;
      yearDropdown.appendChild(option);
    }
  }

  // Cart Observer
  if (window.location.href.includes("cart")) {
    const observer = new MutationObserver(() => {
      initializeCarousel();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  // Scroll to Reviews
  const reviewLink = document.querySelector('.product__info-wrapper .review_card_product_wrapper');
  if (reviewLink) {
    reviewLink.addEventListener('click', function(event) {
      const target = document.querySelector('#AirReviews-BlockWrapper');
      if (!target) return;

      event.preventDefault();
      const header = document.querySelector('.shopify-section-header-sticky');
      const headerHeight = header ? header.offsetHeight : 0;

      const targetPosition = target.getBoundingClientRect().top + window.pageYOffset - headerHeight - 10;

      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      });

      history.replaceState(null, null, window.location.pathname + window.location.search);
    });
  }

});


// ---------------------- Mobile Navigation ----------------------
if (window.innerWidth <= 750) {
  const navTrigger = document.getElementById("navTrigger");
  const navList = document.querySelector(".profile-navigation");

  navList?.classList.add("hidden");

  navTrigger?.addEventListener("click", function () {
    navList.classList.toggle("hidden");
    navTrigger.classList.toggle("navTriggerActive");
  });

  const navListItems = document.querySelectorAll(".profile-navigation li a");
  navListItems?.forEach((item) => {
    item.addEventListener("click", function (event) {
      event.preventDefault();
      const content = this.innerHTML;
      navTrigger.innerHTML = content;
      navList.classList.add("hidden");
      navTrigger.classList.toggle("navTriggerActive");
    });
  });
}